import { isEye } from '@/modules/Editor/annotationTypes/eye'
import { isSkeleton } from '@/modules/Editor/annotationTypes/skeleton'
import type { Action } from '@/modules/Editor/managers/actionManager'
import { inferCurrentAnnotationData } from '@/modules/Editor/inferCurrentAnnotationData'
import type { Annotation } from '@/modules/Editor/models/annotation/Annotation'
import { isVideoAnnotation } from '@/modules/Editor/models/annotation/annotationKindValidator'
import type { View } from '@/modules/Editor/views/view'

import { restoreJoints } from './restoreJoints'
import { updateImageAnnotation } from './utils/updateImageAnnotation'
import { updateVideoAnnotation } from './utils/updateVideoAnnotation'

/**
 * Restore all joints from the skeleton annotation.
 */
export const restoreAllJointsAction = (view: View, annotation: Annotation): Action => {
  const frameIndex = view.currentFrameIndex

  const data = inferCurrentAnnotationData(annotation, frameIndex)

  if (!(isSkeleton(data) || isEye(data))) {
    throw new Error('action: expected annotation of skeleton type')
  }

  const nodes = restoreJoints(data)

  const updatedAnnotation = isVideoAnnotation(annotation)
    ? updateVideoAnnotation(view, annotation, { nodes })
    : updateImageAnnotation(annotation, { nodes })

  return {
    do(): boolean {
      view.annotationManager.updateAnnotation(updatedAnnotation, {
        updatedFramesIndices: [frameIndex],
      })
      return true
    },
    undo(): boolean {
      view.annotationManager.updateAnnotation(annotation, { updatedFramesIndices: [frameIndex] })
      return true
    },
  }
}
